$(document).ready(function () {
  function customBadge() {
    $(".grid-item").each(function () {
      let selectedValue = $(this)
        .find(".swatches.swatch__button")
        .find("a.swatch__link.active")
        .attr("data-swatch");

      if (!selectedValue) {
        $(this).find(".cstmgridproductbadge:first").show();
        return;
      }

      $(this).find(".cstmgridproductbadge").hide();

      $(this)
        .find(".cstmgridproductbadge")
        .each(function () {
          let _thisVal = $(this).attr("badgeattr");
          if (selectedValue === _thisVal) {
            $(this).show();
          }
        });
    });
  }
  customBadge();

  $(document).on(
    "click",
    ".product-item__swatches__holder .swatches.swatch__button",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      let selectedValue = $(this)
        .closest(".grid-item")
        .find("a.swatch__link.active")
        .attr("data-swatch");

      $(this).closest(".grid-item").find(".cstmgridproductbadge").hide();

      $(this)
        .closest(".grid-item")
        .find(".cstmgridproductbadge")
        .each(function () {
          let _thisVal = $(this).attr("badgeattr");
          if (selectedValue === _thisVal) {
            $(this).show();
          }
        });
    }
  );
});
$(document).ready(function () {
  setTimeout(function () {
    $(document)
      .find("body")
      .find(".ks-chart-modal-link")
      .on("click", function () {
        let $var = $(".ks-modal-close");
        var $buttonElement = $("<button>", {
          class: "ks-modal-close",
          "aria-label": "Close The Size Chart",
          "data-modal-close": $var.attr("data-modal-close"),
          role: "button",
        }).html("X");
        $var.replaceWith($buttonElement);
        $buttonElement.on("click", function () {
          $(this).attr("aria-expanded", "false");
          $(".ks-modal").attr("aria-hidden", "true").hide();
        });
      });
  }, 6000);

  $(".header__mobile__hamburger").on("click", function () {
    let $this = $(this).closest(".header__wrapper");
    setTimeout(function () {
      $this.find(".drawer__close").attr("aria-label", "close menu");
    }, 800);
  });
  $(".drawer__close").on("click", function () {
    let $this = $(this);
    setTimeout(function () {
      $this.attr("aria-label", "show menu");
    }, 800);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const vimeo_iframe = document.querySelector(
    ".cstm_vimeo_video_container iframe"
  );
  if (vimeo_iframe) {
    var player = new Vimeo.Player(vimeo_iframe);
    player.ready().then(function () {
      player.getPaused().then(function (isPaused) {
        if (!isPaused) {
        } else {
          player.play();
        }
      });
    });
    player.on("play", function () {
      var imageElement = document.querySelector(
        ".cstm_vimeo_video_container img"
      );
      var iframeElement = document.querySelector(
        ".cstm_vimeo_video_container iframe"
      );

      if (imageElement && iframeElement) {
        imageElement.style.display = "none";
        iframeElement.style.display = "block";
      }
    });
    player.getVideoTitle().then(function (title) {
      var imageElement = document.querySelector(
        ".cstm_vimeo_video_container img"
      );
      var iframeElement = document.querySelector(
        ".cstm_vimeo_video_container iframe"
      );

      if (imageElement && iframeElement) {
        imageElement.style.display = "none";
        iframeElement.style.display = "block";
      }
    });
  }

  let Youtubeiframe = document.querySelector(
    ".cstm_youtube_video_container iframe"
  );
  if (Youtubeiframe) {
    if (typeof YT !== "undefined") {
      var imageElement = document.querySelector(
        ".cstm_youtube_video_container img"
      );
      var iframeElement = document.querySelector(
        ".cstm_youtube_video_container iframe"
      );
      imageElement.style.display = "none";
      iframeElement.style.display = "block";
    }
    var player;
    player = new YT.Player(Youtubeiframe, {
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
        onError: onPlayerError,
      },
    });

    function onPlayerReady(event) {
      var imageElement = document.querySelector(
        ".cstm_youtube_video_container img"
      );
      var iframeElement = document.querySelector(
        ".cstm_youtube_video_container iframe"
      );
      imageElement.style.display = "none";
      iframeElement.style.display = "block";
    }

    function onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
        var imageElement = document.querySelector(".cstm_video_container img");
        var iframeElement = document.querySelector(
          ".cstm_video_container iframe"
        );

        if (imageElement && iframeElement) {
          imageElement.style.display = "none";
          iframeElement.style.display = "block";
        }
      }
    }

    function onPlayerError(event) {
      var imageElement = document.querySelector(".cstm_video_container img");
      var iframeElement = document.querySelector(
        ".cstm_video_container iframe"
      );
      imageElement.style.display = "block";
      iframeElement.style.display = "none";
    }
  }
});

(function () {
  setTimeout(function () {
    $(".cstm_product_wrap").each(function () {
      $(".swatch__link:first", this).addClass("active");
    });
  }, 1000);

  var $carousel = $(".var_images_wrap-2").flickity({
    wrapAround: true,
    pageDots: false,
    groupCells: true,
    cellAlign: "left",

    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30,
    },
  });

  var flkty = $carousel.data("flickity");
  var currentIndex = flkty.selectedIndex;

  var nextVisibleIndex = getNextVisibleIndex(currentIndex);

  $carousel.flickity("select", nextVisibleIndex);

  function getNextVisibleIndex(currentIndex) {
    var flkty = $carousel.data("flickity");
    var cellCount = flkty.cells.length;

    for (var i = currentIndex + 1; i < cellCount; i++) {
      var cell = flkty.cells[i];
      if (cell.isVisible) {
        return i;
      }
    }

    for (var j = 0; j < currentIndex; j++) {
      var cell = flkty.cells[j];
      if (cell.isVisible) {
        return j;
      }
    }

    return currentIndex;
  }

  $(document).on("click", ".swatch__link", function (e) {
    e.preventDefault();
    $(".swatch__link").removeClass("active");
    $(this).addClass("active");
    var altText = $(this)
      .parents(".cstm_product_wrap")
      .find(".product-item__bg__inner1")
      .attr("data-image-alt");
    var color_swatch = $(this).attr("data-swatch");
    $(this)
      .parents(".cstm_product_wrap")
      .find(".product-item__bg__inner1")
      .hide();
    $(this)
      .parents(".cstm_product_wrap")
      .find('.product-item__bg__inner1[data-image-alt="' + color_swatch + '"]')
      .show();
    window.dispatchEvent(new Event("resize"));
  });
})();
const video = document.getElementById("myVideo");
const posterImage = document.getElementById("posterImage");
const iconPath = document.getElementById("iconPath");

video.addEventListener("play", function () {
  posterImage.style.display = "none";
  iconPath.style.display = "none";
  video.style.display = "block";
});

video.addEventListener("pause", function () {
  posterImage.style.display = "block";
  iconPath.style.display = "block";
  video.style.display = "none";
});

video.addEventListener("ended", function () {
  posterImage.style.display = "block";
  video.style.display = "none";
});

playPauseIcon.addEventListener("click", function () {
  if (video.paused || video.ended) {
    video.play();
    iconPath.setAttribute("d", "M6 19L18 12L6 5V19Z");
  } else {
    video.pause();
    iconPath.setAttribute("d", "M8 5v14l11-7z");
  }
});




// $(document).ready(function () {
//   alert("JS loaded");

//   document.addEventListener("variant:change", function (event) {
//     const variant = event.detail.variant;

//     if (!variant) return;
//     const addToCartBtn = document.querySelector("#cstm-add-button");
//     const btnText = addToCartBtn.querySelector(".btn__text");

//     if (variant.available) {
//       addToCartBtn.disabled = false;
//       btnText.textContent = "Add to bag";
//     } else if (
//       variant.inventory_policy === "continue" &&
//       variant.inventory_quantity <= 0
//     ) {
//       addToCartBtn.disabled = true;
//       btnText.textContent = "Pre Order";
//     } else {
//       addToCartBtn.disabled = true;
//       btnText.textContent = "Sold Out";
//     }
//   });
// });
